import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

/**
 * @Description this page String Library's Trim Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Trim({
  action,
  variables,
  setOpenVariable,
  variableRender,
  setField,
  disabled,
  outputVisible,
  visible
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const [trimBegin, setTrimBegin] = useState(false);
  const [trimEnd, setTrimEnd] = useState(false);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

  //set first loaded default trim action value
  useEffect(() => {
    //if there is a trimBegin field when first loaded , set it
    if (action.fields?.trimBegin) {
      if (action.fields.trimBegin?.value !== false) {
        setTrimBegin(true);
      }
    }
    else {
      action.fields.trimBegin = { value: false }
    }
    //if there is a trimEnd field when first loaded , set it
    if (action.fields?.trimEnd) {
      if (action.fields.trimEnd?.value !== false) {
        setTrimEnd(true);
      }
    }
    else {
      action.fields.trimEnd = { value: false }
    }
  }, [action, variables])

  // if checked checkbox , set trim begin value
  function handleChangeBegin(event) {
    setTrimBegin(event.target.checked);

    //if unchecked , set field is a false
    if (!event.target.checked) {
      action.fields.trimBegin = false;
      if (setField) {
        setField('trimBegin', false);
      }
    } else {
      action.fields.trimBegin = { value: "" };
      if (setField) {
        setField('trimBegin', { value: "" });
      }
    }

    const field = initialActionsData[action.id]?.fields.trimBegin;
    const oldValue = !field ? undefined : (field.value === false ? field.value : field);
    const newValue = event.target.checked ? "" : false
    CheckIfFlowUpdated('trimBegin', action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
  }

  // if checked checkbox , set trim end value
  function handleChangeEnd(event) {
    setTrimEnd(event.target.checked);

    //if unchecked , set field is a false
    if (!event.target.checked) {
      action.fields.trimEnd = false;
      if (setField) {
        setField('trimEnd', false);
      }

    } else {
      action.fields.trimEnd = { value: "" };
      if (setField) {
        setField('trimEnd', { value: "" });
      }

    }

    const field = initialActionsData[action.id]?.fields.trimEnd;
    const oldValue = !field ? undefined : (field.value === false ? field.value : field);
    const newValue = event.target.checked ? "" : false
    CheckIfFlowUpdated('trimEnd', action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
  }

  return (
    <div>
      <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
        <FieldLabel name={t(label + "SOURCESTRING")} is_required />
        <TextInput
          action={action}
          inputName="sourceString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          disabled={disabled}
          displayName={t(label + "SOURCESTRING")}
          fieldType={"string"}
        />
      </div>
      <div className="conf-field-container">
        <FormControlLabel
          control={
            <Checkbox
              checked={trimBegin}
              onChange={handleChangeBegin}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              name="checkedI"
              color="#C4C4C4"
            />
          }
          label={t(label + "TRIMBEGIN")}
        />
      </div>
      {trimBegin && (
        <div className="conf-field-container">
          <TextInput
            action={action}
            inputName="trimBegin"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            setField={setField}
          />
          <small className="conf-field-desc"><em>{t(label + "TRIM.BEGIN-INFO")}</em></small>
        </div>
      )}
      <div className="conf-field-container">
        <FormControlLabel
          control={
            <Checkbox
              checked={trimEnd}
              onChange={handleChangeEnd}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              name="checkedI"
              color="#C4C4C4"
            />
          }
          label={t(label + "TRIMEND")}
        />
      </div>

      {trimEnd && (
        <div className="conf-field-container">
          <TextInput
            action={action}
            inputName="trimEnd"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            setField={setField}
          />
          <small className="conf-field-desc"><em>{t(label + "TRIM.END-INFO")}</em></small>
        </div>
      )}
      {
        !outputVisible &&
        <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
          <FieldLabel name={t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")} is_required />
          <VariablePicker
            action={action}
            inputName="set"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            isRequired
            disabled={disabled}
            hideRequired
            filter={"string"}
          />
          <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>

        </div>
      }
    </div>
  );
}
